export default __webpack_public_path__ + "static/Office365-bcf995263f3e79ec60a5fef15cfd4945.svg";